/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationType,
    OrganizationTypeFromJSON,
    OrganizationTypeFromJSONTyped,
    OrganizationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceAdminInvitationInfo
 */
export interface WorkspaceAdminInvitationInfo {
    /**
     * The icon of the inviting organization. A square 128px x 128px.
     * @type {string}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviterIcon?: string;
    /**
     * The inviting organization's unique identifier.
     * @type {string}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviterOrganizationId?: string;
    /**
     * The name of the inviting organization.
     * @type {string}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviterOrganizationName?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviterOrganizationType?: OrganizationType;
    /**
     * The inviting workspace unique identifier.
     * @type {string}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviterWorkspaceId?: string;
    /**
     * The name of the inviting workspace.
     * @type {string}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviterWorkspaceName?: string;
    /**
     * A prompt for the invitee, to encourage them to accept the invitation.
     * @type {string}
     * @memberof WorkspaceAdminInvitationInfo
     */
    inviteText?: string;
    /**
     * The last modified time of the invitation.
     * @type {Date}
     * @memberof WorkspaceAdminInvitationInfo
     */
    updatedAt?: Date;
}

export function WorkspaceAdminInvitationInfoFromJSON(json: any): WorkspaceAdminInvitationInfo {
    return WorkspaceAdminInvitationInfoFromJSONTyped(json, false);
}

export function WorkspaceAdminInvitationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceAdminInvitationInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inviterIcon': !exists(json, 'inviterIcon') ? undefined : json['inviterIcon'],
        'inviterOrganizationId': !exists(json, 'inviterOrganizationId') ? undefined : json['inviterOrganizationId'],
        'inviterOrganizationName': !exists(json, 'inviterOrganizationName') ? undefined : json['inviterOrganizationName'],
        'inviterOrganizationType': !exists(json, 'inviterOrganizationType') ? undefined : OrganizationTypeFromJSON(json['inviterOrganizationType']),
        'inviterWorkspaceId': !exists(json, 'inviterWorkspaceId') ? undefined : json['inviterWorkspaceId'],
        'inviterWorkspaceName': !exists(json, 'inviterWorkspaceName') ? undefined : json['inviterWorkspaceName'],
        'inviteText': !exists(json, 'inviteText') ? undefined : json['inviteText'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function WorkspaceAdminInvitationInfoToJSON(value?: WorkspaceAdminInvitationInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inviterIcon': value.inviterIcon,
        'inviterOrganizationId': value.inviterOrganizationId,
        'inviterOrganizationName': value.inviterOrganizationName,
        'inviterOrganizationType': OrganizationTypeToJSON(value.inviterOrganizationType),
        'inviterWorkspaceId': value.inviterWorkspaceId,
        'inviterWorkspaceName': value.inviterWorkspaceName,
        'inviteText': value.inviteText,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


